/**
 * EditModal
 */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useApi2call } from 'containers/Api2/index.js';
import prepareTheme from 'containers/ThemeProvider/prepareTheme.js';
import FormModal from 'components/interaction/FormModal/index.jsx';
import doNothing from 'utils/doNothing.js';
import messages from '../messages.js';
import schema from './form.js';
import adminParser from '../../../adminParser.js';
import getPathBase from '../../../getPathBase.js';

function prepareSubmit(data) {
  const { name, groupType, ...rest } = data;
  return {
    name,
    groupType,
    theme: prepareTheme(rest),
  };
}

function EditModal(props) {
  const { onHide, group, show, title } = props;
  const api2call = useApi2call();
  const navigate = useNavigate();
  const { name, theme, typeName, groupType } = group || {};
  const defaultValues = { name, groupType };
  if (theme) {
    Object.assign(defaultValues, {
      tagLine: theme.tagLine,
      logo: theme.logo,
      color: theme.themeColor.hex,
    });
  }

  const handleSubmit = useCallback((data) => {
    const postfix = group.id ? `/${group.id}` : '';
    const url = `sa/groups${postfix}`;
    const selector = `sa/groups/${typeName}${postfix}`;
    api2call({
      method: group.id ? 'PUT' : 'POST',
      url,
      selector,
      version: 2,
      body: prepareSubmit(data),
      succes: messages.saveSuccess,
      parser: adminParser,
      withPromise: true,
    })
      .then((res) => {
        if (group.id) {
          onHide();
        } else {
          navigate(`/${getPathBase()}/groups/${res.typeName}/${res.id}`);
        }
      })
      .catch(doNothing);
  }, [api2call, group?.id, navigate, onHide, typeName]);

  return (
    <FormModal
      show={show}
      onHide={onHide}
      title={title}
      horizontal
      defaultValues={defaultValues}
      schema={schema}
      onSubmit={handleSubmit}
    />
  );
}

EditModal.propTypes = {
  onHide: PropTypes.func,
  group: PropTypes.object,
  title: PropTypes.object,
  show: PropTypes.bool,
};

export default EditModal;
